var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-main-container"},[_c('section',[_c('transition',{attrs:{"mode":"out-in","name":"fade-transform"}},[_c('keep-alive',{attrs:{"include":_vm.keepAliveNameList,"max":_vm.keepAliveMaxNum}},[_c('router-view',{key:_vm.routerKey})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }